import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgDk = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#D80027",
      d: "m.089 13.466 1.29-1.447-1.291-1.48C.626 6.105 3.584 2.416 7.602.833l.193.12.747-.446A12 12 0 0 1 12 0c6.144 0 11.21 4.617 11.916 10.57L23.034 12l.882 1.43C23.209 19.382 18.144 24 12 24c-1.16 0-2.283-.165-3.345-.472l-.752-.484-.249.145C3.611 21.617.631 17.919.09 13.466Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#EEE",
      d: "M9.39.285a12 12 0 0 0-3.128 1.173v8.976H.103a12 12 0 0 0 0 3.132h6.16v8.976c.97.529 2.02.927 3.127 1.173v-10.15H23.9a12 12 0 0 0 0-3.13H9.389V.284Z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgDk;